var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTriangleRightFilledUnhovered(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 10,
    viewBox: "0 0 7 10",
    fill: "black",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 1.00188C0 0.163574 0.969521 -0.302663 1.62435 0.220735L6.62473 4.21746C7.12559 4.61779 7.12559 5.37941 6.62473 5.77974L1.62435 9.77647C0.96952 10.2999 0 9.83363 0 8.99532V1.00188Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTriangleRightFilledUnhovered);
export default __webpack_public_path__ + "static/media/triangle-right-filled-unhovered.2ae8eff435ec7cda95470a035776167a.svg";
export { ForwardRef as ReactComponent };